// extracted by mini-css-extract-plugin
export default {"scrollingTextContainer":"scrollingText_scrollingTextContainer__4Xej2","scroll":"scrollingText_scroll__Z3RZ6"};